import { Generator, getGenerators } from "@prisma/internals";
import { PrismaClientPath, PrismaEnginePath } from "./paths";
import { debug } from "./utils/debug";

type GetGeneratorOptions = {
  schemaPath: string;
  forceBinary: boolean;
  forceLibrary: boolean;
  paths: {
    queryEngine?: PrismaEnginePath;
    prismaClient: PrismaClientPath;
  };
};

/**
 * Returns a Prisma Client generator
 */
export async function getGenerator({
  schemaPath,
  forceBinary,
  forceLibrary,
  paths,
}: GetGeneratorOptions): Promise<Generator> {
  debug("[getDMMF] Calling getGenerator with:", {
    paths,
  });

  const prismaGenerators = await getGenerators({
    schemaPath: schemaPath,
    // printDownloadProgress: true,
    skipDownload: forceLibrary || forceBinary || false,
    overrideGenerators: [
      {
        name: "studio-client",
        provider: {
          fromEnvVar: "",
          value: "prisma-client-js",
        },
        previewFeatures: ["driverAdapters"],
        output: { fromEnvVar: "", value: "" },
        binaryTargets: [],
        config: {},
        sourceFilePath: "schema.prisma",
      },
    ],
    binaryPathsOverride: paths.queryEngine
      ? {
          [paths.queryEngine.type === "binary"
            ? "queryEngine"
            : "libqueryEngine"]: paths.queryEngine.path,
        }
      : undefined,
    providerAliases: {
      "prisma-client-js": {
        generatorPath: `${paths.prismaClient}/generator-build/index.js`,
        outputPath: "", // Does not matter, we won't generate on disk
        isNode: true,
      },
    },
  });

  const prismaClientGenerator = prismaGenerators.find(
    g => g.config.provider.value === "prisma-client-js"
  );

  if (!prismaClientGenerator) {
    throw new Error("Unable to get Prisma Client generator. This is a bug.");
  }

  // Stop all other generators
  prismaGenerators
    .filter(g => g.config.provider.value !== "prisma-client-js")
    .forEach(g => g.stop());

  return prismaClientGenerator;
}
